import { useSelector } from "react-redux";
import LineChart from "common/Charts/LineChart/LineChart";
import { selectDisplayCurrency } from "@shared/slices/common.slice";
import ChartCardLayout from "common/Layouts/ChartCardLayout";
import ChangeInfo from "common/Charts/ChangeInfo";
import { FixMeLater, RequestStatus } from "types";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { Filters, LanguageNameSpaces, PrecisionType } from "@shared/types";
import { selectPortfolioHistoryGraphPrecision } from "@shared/slices/portfolio.slice";
import React, { CSSProperties } from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface AccountChartProps {
  filters: Filters;
  status?: RequestStatus;
  data: FixMeLater[];
  precisionSelector: FixMeLater;
  autoLayoutHeight?: boolean;
  loading: boolean;
  isSuccess: boolean;
  style?: CSSProperties;
}

const AccountChart = ({
  filters,
  loading,
  data,
  autoLayoutHeight = true,
  isSuccess,
  style,
}: AccountChartProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  const displayCurrency = useSelector(selectDisplayCurrency);
  const selectedTimeRange = useSelector(
    filters.selectors.selectTimeRangeFilter
  );

  return (
    <ChartCardLayout
      change={
        <ChangeInfo
          title={
            <div style={{ display: "flex" }}>
              {t("common.portfolio_change")}
              <HelperTooltip
                analyticsPageName={"Accounts"}
                analyticsFieldName={t("common.portfolio_change")}
                description={t("common.portfolio_change_tooltip")}
              />
            </div>
          }
          data={data}
          // TODO: fix precision selector
          precisionSelector={selectPortfolioHistoryGraphPrecision}
          precisionType={PrecisionType.BALANCE}
        />
      }
      chart={
        <LineChart
          data={data}
          loading={loading}
          isSuccess={isSuccess}
          displayCurrency={displayCurrency}
          precision={2}
        />
      }
      selectedTimeRange={selectedTimeRange}
      filtersActions={filters.actions}
      mobileBreakpoint={650}
      autoLayoutHeight={autoLayoutHeight}
      style={style}
    />
  );
};

export default React.memo(AccountChart);
